import { canUseDOM } from '@ps/web-core-utils';

import { TXTWCL_N0_time, TXTWCL_N0_times } from './index.messages.json';

/**
 * Adjusts the font size of the provided elements to fit within their parent elements.
 * @param {HTMLElement[]} elements - An array of HTML elements whose font size needs to be adjusted.
 * @param {number} maxFontSize - The maximum font size to start with.
 * @returns {number} - The adjusted font size that fits within the parent elements.
 */
export function adjustFontSizeToFit(elements: HTMLElement[], maxFontSize: number): number {
  const minFontSize = 12; // Minimum font size in pixels
  const extraSpace = 24;
  let fontSize = maxFontSize;

  // Reset font size to maxFontSize initially for all elements
  elements.forEach((element) => {
    element.style.fontSize = `${fontSize}px`;
  });

  // Adjust font size until the text fits within all elements
  while (fontSize >= minFontSize) {
    let allFit = true;
    elements.forEach((element) => {
      if (
        element.parentElement &&
        !!element.offsetWidth &&
        !!element?.parentElement?.parentElement?.clientWidth &&
        element.offsetWidth + extraSpace >= element?.parentElement?.parentElement?.clientWidth
      ) {
        allFit = false;
      }
    });

    if (allFit) {
      break;
    } else {
      fontSize--;
      elements.forEach((element) => {
        element.style.fontSize = `${fontSize}px`;
      });
    }
  }

  return fontSize;
}

/**
 * Determines the maximum font size based on the current window width.
 * @returns {number} - The maximum font size in pixels.
 */
export function getMaxFontSize(): number {
  let maxFontSize = 46; // Maximum font size in pixels
  if (canUseDOM) {
    switch (true) {
      case window.innerWidth <= 725:
        maxFontSize = 36;
        break;
      case window.innerWidth > 725 && window.innerWidth <= 1230:
        maxFontSize = 28;
        break;
      case window.innerWidth > 1230:
        maxFontSize = 46;
        break;
    }
  }
  return maxFontSize;
}

/**
 * Extracts and formats the text based on the provided placeholder value.
 * @param {number} placeholder - The numeric value to be inserted into the text.
 * @returns {string} - The formatted text with the placeholder value.
 */
export function plainText(placeholder: number): string {
  const wonTodayText = placeholder === 1 ? TXTWCL_N0_time : TXTWCL_N0_times;

  const plainTextWonToday = wonTodayText.defaultMessage.replace('{0}', placeholder.toString());

  return plainTextWonToday;
}
